// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartCallButton__menu-f38e78 {
  min-width: 190px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/DefaultHeaderActions/StartCallButton/StartCallButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".menu {\n  min-width: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `StartCallButton__menu-f38e78`
};
module.exports = ___CSS_LOADER_EXPORT___;
